export default {
  title: 'Inspection Report',

  section1Title: '1. Task Information',
  section2Title: '2. Statistics Overview',
  section3Title: '3. Inspection Content and Results',
  section4Title: '4. Comprehensive Conclusion',

  deviceSn: 'Device Serial Number',
  location: 'Inspection Location',
  executionTime: 'Execution Time',
  taskStatus: 'Task Status',
  completed: 'Completed',

  totalAnomalies: 'Total Anomalies Detected',
  abnormalHeatSourceCount: 'Abnormal Heat Source Count',
  stackedObjectCount: 'Stacked Object Count',
  unit: '',

  alarmDetails: 'Alarm Details',
  totalAlarms: 'Total {count} Alarms',

  subItem: 'Sub-item',
  standard: 'Standard/Requirement',
  result: 'Result',
  remarks: 'Issues/Suggestions',

  serialNumber: 'No.',
  problemDescription: 'Problem Description',
  urgency: 'Urgency',
  status: 'Status',

  alarmType: 'Alarm Type',
  positionXY: 'Position (X, Y)',
  createTime: 'Created At',
  alarmImage: 'Alarm Image',

  labelRivet: 'Rivet',
  labelCutterHandle: 'Cutter Handle',
  labelScrewdriver: 'Screwdriver',
  labelBackpack: 'Backpack',
  labelBottle: 'Bottle',

  qualified: 'Qualified',
  unqualified: 'Unqualified',
  attention: 'Attention',

  urgencyEmergency: 'Emergency',
  urgencyHigh: 'High',
  urgencyMedium: 'Medium',
  urgencyLow: 'Low',

  inspectionCategory: 'Inspection Item',
  inspectionCheck: '{name} Inspection',
  standardNotFound: 'No {name} detected',
  remarksDetected: 'Detected {count} {name} location(s). Timely action is recommended.',
  remarksNotFound: 'No {name} detected. Meets requirements.',

  rectificationDetected: 'Detected {count} {name} location(s). Please address and re-inspect promptly.',
  responsibleSafety: 'Safety Management',
  deadline3Days: 'Within 3 business days',
  statusPending: 'Pending',

  defaultLocation: '919 Shangfei Road, Zhuqiao Town, Pudong New Area, Shanghai',
  reportSummaryIntro: 'Robot dog {sn} performed an inspection at {location} at {createTime}. The task is completed.',
  inspectionSummary: 'Inspection summary:',
  noAnomaly: 'No anomalies',
  foundAnomalies: 'Found {content}',
  anomalyRecords: 'Anomaly records:',
  conclusionAndSuggestion: 'Inspection conclusion and suggestions:',
  suggestTimelyHandle: 'Timely handling and re-inspection are recommended',
  foundPrefix: 'Found {content}',
  foundWithSuggestion: 'Found {content}, {suggestion}',
  noAnomalyFound: 'No anomalies found',
  listSeparator: ', ',

  conclusionPrefix: 'This inspection',
  conclusionNonCompliant: ' found {count} unqualified item(s) requiring immediate corrective action;',
  conclusionAttention: ' found {count} risk point(s) requiring close attention.',
  conclusionFollowUp: 'Please implement corrective measures according to the recommendations and track progress.',
  conclusionWithAlarms: 'This inspection generated {count} alarm record(s). Please verify and handle them using the inspection details and alarm list.',
  conclusionAllGood: 'The inspection was completed successfully. No abnormalities were found and all indicators meet requirements.',

  missingTaskId: 'Missing task ID. Unable to load inspection report data.',
  requestFailed: 'Request failed',
}
